/* Page collection — Le Temple du Foot (31/10/2026) :
   colonne « Par thème » dans les filtres verticaux, curseur de prix, bouton « Découvrir » au survol,
   bouton « Filtres » qui replie la colonne, vue liste avec « Afficher les détails ». */
(function(){
  var rootEl=document.getElementById('ltc-root');
  var label=rootEl?(rootEl.getAttribute('data-cta')||'Découvrir'):'Découvrir';
  var detailLabel=rootEl?(rootEl.getAttribute('data-detail')||'Afficher les détails'):'Afficher les détails';
  function store(k,v){try{sessionStorage.setItem(k,v);}catch(e){}}
  function read(k){try{return sessionStorage.getItem(k);}catch(e){return null;}}

  /* bouton Découvrir */
  function cta(){
    document.querySelectorAll('.product-grid .card-gallery:not([data-ltc])').forEach(function(g){
      g.setAttribute('data-ltc','1');
      if(getComputedStyle(g).position==='static')g.style.position='relative';
      var s=document.createElement('span');s.className='ltc-cta';s.textContent=label;g.appendChild(s);
    });
  }

  /* vue liste : titre + prix regroupés, bouton « Afficher les détails » (toute la carte est cliquable) */
  function rows(){
    document.querySelectorAll('.product-grid .product-grid__card:not([data-ltc-row])').forEach(function(c){
      c.setAttribute('data-ltc-row','1');
      var kids=Array.prototype.filter.call(c.children,function(k){return !k.classList.contains('card-gallery')&&!k.classList.contains('ltc-info')&&!k.classList.contains('ltc-detail');});
      if(kids.length){var info=document.createElement('div');info.className='ltc-info';c.insertBefore(info,kids[0]);kids.forEach(function(k){info.appendChild(k);});}
      var d=document.createElement('span');d.className='ltc-detail';d.textContent=detailLabel;c.appendChild(d);
    });
  }

  /* bouton Filtres : replie / déplie la colonne (ordinateur) */
  function filters(){
    var wrap=document.querySelector('.collection-wrapper');if(!wrap)return;
    var off=read('ltc_filters')==='off'&&window.innerWidth>=750;
    wrap.classList.toggle('ltc-nofilters',off);
    document.querySelectorAll('.facets--filters-title').forEach(function(t){
      t.classList.toggle('is-off',off);
      if(!t.hasAttribute('role')){t.setAttribute('role','button');t.tabIndex=0;}
      t.setAttribute('aria-expanded',off?'false':'true');
    });
  }
  function flip(){store('ltc_filters',read('ltc_filters')==='off'?'on':'off');filters();}
  document.addEventListener('click',function(e){var t=e.target.closest&&e.target.closest('.facets--filters-title');if(t&&window.innerWidth>=750){e.preventDefault();flip();}});
  document.addEventListener('keydown',function(e){if((e.key==='Enter'||e.key===' ')&&e.target&&e.target.classList&&e.target.classList.contains('facets--filters-title')&&window.innerWidth>=750){e.preventDefault();flip();}});

  /* « Par thème » en tête de la colonne de filtres (desktop) */
  function side(){
    var aside=document.querySelector('.ltc-side');if(!aside)return;
    var col=document.querySelector('.facets-block-wrapper--vertical:not(#filters-drawer) .facets--vertical');
    if(window.innerWidth>=750&&col){if(aside.parentNode!==col)col.insertBefore(aside,col.firstChild);}
    else{var wrap=document.querySelector('.collection-wrapper');var grid=wrap&&wrap.querySelector('.main-collection-grid');if(grid&&aside.nextElementSibling!==grid)wrap.insertBefore(aside,grid);}
  }

  /* curseur de prix (deux poignées) relié aux champs min / max du thème */
  function num(s){s=String(s||'').replace(/\s/g,'').replace(',','.');var n=parseFloat(s);return isNaN(n)?null:n;}
  function fmt(n){return (Math.round(n*100)/100).toFixed(2).replace('.',',').replace(/,00$/,'');}
  function range(){
    document.querySelectorAll('price-facet-component:not([data-ltc-range])').forEach(function(pf){
      var mn=pf.querySelector('[ref="minInput"]'),mx=pf.querySelector('[ref="maxInput"]');if(!mn||!mx)return;
      var max=num(mx.getAttribute('data-max'))||num(mx.placeholder);if(!max)return;
      pf.setAttribute('data-ltc-range','1');
      var box=document.createElement('div');box.className='ltc-range';
      box.innerHTML='<i></i><input type="range" min="0" max="'+max+'" step="1" aria-label="Prix minimum"><input type="range" min="0" max="'+max+'" step="1" aria-label="Prix maximum">';
      var wrap=pf.querySelector('.price-facet__inputs-wrapper');(wrap||pf).insertAdjacentElement('beforebegin',box);
      var bar=box.querySelector('i'),lo=box.querySelectorAll('input')[0],hi=box.querySelectorAll('input')[1];
      lo.value=num(mn.value)||0;hi.value=num(mx.value)||max;
      function paint(){var a=+lo.value,b=+hi.value;bar.style.left=(a/max*100)+'%';bar.style.right=(100-b/max*100)+'%';}
      function push(ev){if(+lo.value>+hi.value-1){if(ev.target===lo)lo.value=+hi.value-1;else hi.value=+lo.value+1;}paint();
        mn.value=+lo.value>0?fmt(+lo.value):'';mx.value=+hi.value<max?fmt(+hi.value):'';}
      lo.addEventListener('input',push);hi.addEventListener('input',push);
      function commit(){var t=document.createEvent('Event');t.initEvent('change',true,true);mx.dispatchEvent(t);}
      lo.addEventListener('change',commit);hi.addEventListener('change',commit);
      paint();
    });
  }

  var t;
  function all(){cta();rows();side();range();filters();}
  function boot(){all();new MutationObserver(function(){clearTimeout(t);t=setTimeout(all,60);}).observe(document.body,{childList:true,subtree:true});window.addEventListener('resize',function(){side();filters();});}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
